import { Component } from '@angular/core';

@Component({
    selector: 'mon-overlay-spinner',
    templateUrl: './loading-spinner.html',
    styleUrls: ['./loading.scss'],
    standalone: false,
})
export class MonOverlaySpinner {}
